import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { DatagridService, NotificationService, PagedResultGeneric, PagedSearch, TranslationService } from 'src/app/shared';
import { SecurityElementNames } from 'src/app/shared/auth/constants/security-element-names.service';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { PledgeCampaignSearchDto } from '../shared/pledge-campaign/dto/pledge-campaign-search.dto';
import { PledgeCampaignDto } from '../shared/pledge-campaign/dto/pledge-campaign.dto';
import { PledgeCampaignService } from '../shared/pledge-campaign/pledge-campaign.service';
import { debounce } from 'lodash-decorators';
import { PledgeCampaignsAddDialogComponent } from './pledge-campaigns-add-dialog/pledge-campaigns-add-dialog.component';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';

@Component({
  selector: 'wl-pledge-campaigns',
  templateUrl: './pledge-campaigns.component.html',
  styleUrls: ['./pledge-campaigns.component.less'],
    standalone: false
})
export class PledgeCampaignsComponent extends LazySelectableTableComponent<PledgeCampaignSearchDto, PledgeCampaignDto> implements OnInit {
  @ViewChild(PledgeCampaignsAddDialogComponent) private _addDialog: PledgeCampaignsAddDialogComponent;
  rowMenuItems = new Map<number, MenuItem[]>();

  constructor(
    datagridService: DatagridService,
    private _pledgeCampaignService: PledgeCampaignService,
    private _translationService: TranslationService,
    private _navigationService: NavigationService,
    private _confirmationService: ConfirmationService,
    private _notificationService: NotificationService,
    public securityElementNames: SecurityElementNames
  ) {
    super('PledgeCampaignId', datagridService);
    this.searchParams = new PagedSearch() as PledgeCampaignSearchDto;
  }

  ngOnInit(): void {
    this.searchParams.OrderBy = 'CampaignYear:desc';
  }

  public fetchResults(): Promise<PagedResultGeneric<PledgeCampaignDto>> {
    return this._pledgeCampaignService.searchPledgeCampaigns(this.searchParams);
  }

  public pageSizeChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }

  public openPledgeCampaignsAddDialog() {
    this._addDialog.open();
  }

  @debounce(500)
  filterChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }

  actionItemsForPledgeCampaign(pledgeCampaign: PledgeCampaignDto): MenuItem[] {
    if (!this.rowMenuItems.has(pledgeCampaign.PledgeCampaignId)) {
      this.rowMenuItems.set(pledgeCampaign.PledgeCampaignId, [
        {
          label: this._translationService.getInstantTitlecase('common.edit'),
          command: () => this.editPledgeCampaign(pledgeCampaign),
        },
        {
          label: this._translationService.getInstantTitlecase('common.delete'),
          command: () => this.deletePledgeCampaign(pledgeCampaign),
        },
      ]);
    }
    return this.rowMenuItems.get(pledgeCampaign.PledgeCampaignId);
  }

  pledgeInvoiceReports() {
    this._navigationService.navigateRevenuePledgesAndInvoicesReport();
  }
  private editPledgeCampaign(pledgeCampaign: PledgeCampaignDto) {
    this._navigationService.navigateToPledgeCampaignEdit(pledgeCampaign.PledgeCampaignId);
  }

  private deletePledgeCampaign(pledgeCampaign: PledgeCampaignDto) {
    this._confirmationService.confirm({
      message: this._translationService.getInstantTitlecase('revenue.pledge-campaigns.delete-message'),
      key: 'deletePledgeCampaignCD',
      accept: () => {
        this.loading = true;
        this._pledgeCampaignService.deletePledgeCampaign(pledgeCampaign.PledgeCampaignId).then(
          () => {
            this._notificationService.translateSuccess('revenue.pledge-campaigns.pledge-campaign-deleted');
            this.search();
          },
          (error) => {
            this._notificationService.httpError(error);
          }
        );
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }
}
